<template>
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Eventos</span>
      </v-row>
      <v-row>
        <v-col md="9" sm="12" cols="12">
          <v-row justify="center" v-if="eventos.length == 0" class="mr-3 mt-4">
            <v-card class="borda" flat width="100%" height="75">
              <v-row justify="center" class="mt-5">
                <v-subheader>Nenhum evento cadastrado</v-subheader>
              </v-row>
            </v-card>
          </v-row>
          <v-row justify="start" v-else>
            <v-col
              class="mt-n8"
              cols="12"
              sm="12"
              md="6"
              v-for="(item, index) in eventos"
              :key="index"
            >
              <v-card flat width="100%" min-height="240" class="mt-8 borda">
                <v-container fluid class="pb-0">
                  <v-card-title class="pa-0">
                    <span class="font-weight-bold headline ml-2 mt-1">{{item.evento_nome}}</span>
                    <v-spacer></v-spacer>
                    <span
                      class="green--text font-weight-bold body-1"
                      v-if="item.evento_status == 1"
                    >Ativo</span>
                    <span class="red--text font-weight-bold body-1" v-else>Desativado</span>
                  </v-card-title>
                  <v-card-text class="mt-2">
                    <v-row align="end">
                      <v-col cols="auto" sm="auto" md="auto">
                        <v-avatar
                          size="120"
                          tile
                          v-if="item.evento_imagem.charAt(item.evento_imagem.length - 1) != '/'"
                        >
                          <v-img height="120" contain :src="item.evento_imagem"></v-img>
                        </v-avatar>
                        <v-avatar size="120" tile class="borda" color="#283480" v-else>
                          <span
                            class="white--text headline text-uppercase"
                          >{{item.evento_nome.charAt(0)}}</span>
                        </v-avatar>
                      </v-col>
                      <v-col md="6">
                        <v-row>
                          <span class="subtitle-2">
                            <span v-text="evento_aberto(item)"></span>
                          </span>
                        </v-row>
                        <v-row>
                          <span class="subtitle-2">
                            <span class="black--text font-weight-bold mr-1">Local:</span>
                            <span class="font-weight-light">{{item.evento_local}}</span>
                          </span>
                        </v-row>
                        <v-row>
                          <span class="subtitle-2">
                            <span class="black--text font-weight-bold mr-1">Data:</span>
                            <span class="font-weight-light" v-text="data(item)"></span>
                          </span>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="auto">
                        <v-row>
                          <v-btn
                            text
                            icon
                            :to="'/meus_eventos/participantes/'+ item.id_evento"
                            v-if="editModulo"
                          >
                            <v-icon>mdi-account-outline</v-icon>
                          </v-btn>
                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-row justify="center">
                                <v-col>
                                  <v-btn icon v-bind="attrs" v-on="on" text>
                                    <v-icon>mdi-information-outline</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">acessar</span>
                              os participantes
                            </span>
                          </v-tooltip>
                        </v-row>
                      </v-col>

                      <v-spacer></v-spacer>
                      <v-col md="auto">
                        <v-btn
                          :to="'meus_eventos/compras/'+ item.id_evento"
                          class="white--text"
                          rounded
                          color="#283480"
                        >Ver Evento</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col md="3" sm="12" cols="12">
          <v-row>
            <v-card flat width="100%" height="100%" class="mt-3 mr-4 borda">
              <v-col class="mr-8">
                <!-- <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-row justify="center">
                      <v-btn icon v-bind="attrs" v-on="on" text>
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-row>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">cadastrar</span>
                    um novo evento
                  </span>
                </v-tooltip>-->
                <!-- <v-btn
                  v-if="editModulo"
                  large
                  rounded
                  to="/eventos/detalhes/0"
                  block
                  class="mt-1"
                  style="background-color: #283480  !important;"
                >
                  <v-icon class="agua mr-1">mdi-calendar</v-icon>
                  <span class="white--text">Novo Evento</span>
                </v-btn>-->
                <v-btn
                  large
                  rounded
                  block
                  class="mt-4"
                  style="background-color: #283480  !important;"
                  @click="dialog_relatorio = true"
                >
                  <v-icon class="agua mr-1">mdi-file-document-outline</v-icon>
                  <span class="white--text">Relatório</span>
                </v-btn>

                <v-col v-if="eventosAtivos.length > 1000" class="mt-7">
                  <span class="title">Eventos ativos</span>

                  <div class="progress_bar my-3">
                    <!-- <div
                      class="item"
                      :title="item.orcamento_nome+' - '+item.porcentagem+'%'"
                      v-for="item in orcamento_listagem"
                      :key="item.orcamento_nome"
                      :style="'width:'+item.porcentagem2+'%; background-color:'+item.orcamento_cor+';'"
                    ></div>-->
                  </div>
                  <v-simple-table height="100%">
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="(item,index) in eventosAtivos" :key="index">
                          <td>
                            <!-- :color="item.orcamento_cor" -->
                            <v-icon color="#283480" x-small>mdi-checkbox-blank-circle</v-icon>
                            {{ item.evento_nome }}
                          </td>
                          <td>
                            <v-row justify="end">
                              <!-- <span>{{ item.porcentagem }}%</span> -->
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog_remover" persistent max-width="310">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este item?</v-card-title>
        <v-card-text>Se deletar este item ele não poderá ser recuperado!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            :disabled="loading_delete"
            rounded
            color="#283480"
            @click="dialog_remover = false"
          >Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            :loading="loading_delete"
            :disabled="loading_delete"
            @click="deleteEvento(id_evento)"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_relatorio" max-width="900" scrollable>
      <v-card class="borda" flat min-height="525">
        <v-card-title class="ma-2">
          Relatório
          <v-spacer></v-spacer>
          <v-btn icon text @click="dialog_relatorio=false, link_relatorio = ''">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-row class="ml-4 mt-5">
          <v-col cols="12" sm="3" md="8">
            <VueCtkDateTimePicker
              class="date-picker"
              locale="pt-BR"
              aria-label="Período"
              v-model="relatorio.data"
              :no-header="true"
              :range="true"
              :formatted="'L'"
              :format="'YYYY-MM-DD'"
              :label="'Período'"
              :custom-shortcuts="labels"
              :no-button="true"
              :auto-close="true"
              :noClearButton="true"
              :no-label="true"
              :shortcut="'last30Days'"
            ></VueCtkDateTimePicker>
          </v-col>
          <v-col cols="12" sm="3" md="4">
            <v-checkbox
              class="mt-0"
              v-model="relatorio.relatorio_check"
              label="Relatório detalhado"
              color="#283480"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn
              rounded
              color="#283480"
              :loading="loading"
              :disabled="loading"
              target="_blank"
              class="white--text ml-n3"
              @click="getRelatorio()"
            >Gerar</v-btn>
            <v-btn
              rounded
              color="#283480"
              class="white--text ml-3"
              :href="link_relatorio"
              v-if="link_relatorio != null"
            >Acessar relatório ></v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import moment from "moment";
import Api from "@/common/api.helper";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
export default {
  components: {
    VueCtkDateTimePicker
  },
  data: () => {
    return {
      eventosAtivos: [],
      labels: [
        { key: "thisDay", label: "Hoje", value: "day" },
        { key: "last30Days", label: "Últimos 30 dias", value: 30 },
        { key: "thisMonth", label: "Este mês", value: "month" },
        { key: "lastMonth", label: "Mês passado", value: "-month" },
        { key: "thisYear", label: "Este ano", value: "year" },
        { key: "lastYear", label: "Últ. ano", value: "-year" }
      ],
      link_relatorio: null,
      relatorio: {
        data: {
          start: moment().subtract(30, "days"),
          end: moment()
        },
        relatorio_check: false
      },
      loading: false,
      participantesModulo: false,
      editModulo: false,
      eventos: [],
      dialog_remover: false,
      dialog_relatorio: false,
      id_evento: "",
      loading_delete: false
    };
  },
  mounted() {
    this.validaEdicaoModulo();
    this.getAtivos();
    this.getEventos();
  },

  methods: {
    validaEdicaoModulo() {
      this.clubeAtual = JSON.parse(localStorage.getItem("clube-atual"));
      this.modulos = this.clubeAtual.modulos;
      for (let i = 0; i < this.modulos.length; i++) {
        if (this.modulos[i].id_modulo == 18) {
          this.editModulo = true;
        }
      }
    },
    data(item) {
      let inicio = item.evento_data_inicio;
      let fim = item.evento_data_fim;
      let data = "";
      let inicio2 = inicio.substr(0, 10);
      let fim2 = fim.substr(0, 10);
      let hora1 = inicio.substr(10, 6);
      let hora2 = fim.substr(10, 6);

      if (moment(inicio2).isSame(fim2)) {
        data =
          moment(inicio).format("L") + " das " + hora1 + "h às " + hora2 + "h";
      } else {
        data =
          moment(inicio).format("L") +
          " " +
          hora1 +
          "h até " +
          moment(fim).format("L") +
          " " +
          hora2 +
          "h";
      }
      return data;
    },
    evento_aberto(item) {
      let text = "";
      if (item.evento_tipo == 1) {
        text = "Aberto ao Público";
      } else {
        text = "Restrito para associados";
      }
      return text;
    },
    getEventos() {
      Api.get("/meu_titulo/eventos")
        .then(response => {
          if (!response.data.errors) {
            this.eventos = response.data.data;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    getAtivos() {
      Api.get("/meu_titulo/eventos-ativos")
        .then(response => {
          if (!response.data.errors) {
            this.eventosAtivos = response.data;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    getRelatorio() {
      let tipo = this.relatorio.relatorio_check == true ? 1 : 0;
      this.loading = true;
      let rota =
        "?data_inicial=" +
        moment(this.relatorio.data.start).format("YYYY-MM-DD") +
        "&data_final=" +
        moment(this.relatorio.data.end).format("YYYY-MM-DD") +
        "&tipo=" +
        tipo;
      Api.get("/meu_titulo/relatorio" + rota)
        .then(response => {
          let file = response.data.link;
          this.link_relatorio = response.data.link;
          let link = document.createElement("a");
          link.href = file;
          link.download = "Relatorio_eventos.pdf";
          link.target = "_blank";
          link.click();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error("Oops, erro ao gerar o relatório");
          throw err;
        });
    }
  }
};
</script>

<style>
</style>